import { createFileRoute } from '@tanstack/react-router'

import { LineItemsPage } from '@/pages/line-items/LineItemsPage'

export const Route = createFileRoute('/_authenticated/_dashboard/line-items/')({
  component: LineItemsPage,
})
